import {findIndex} from 'lodash';

const defaultState = {
  items: [],
  sessions: [],
  item: {},
  slide: null,
  loaded: false,
  loaded_imgs: true,
}


const presentation = (state = defaultState, action) => {
  switch (action.type) {
    case 'GET_PRESENTATION':
      return {...state, item: action.data, loaded: action.items.filter(_i => _i.type == 'image').length == 0, items: action.items}
    case 'SET_PRESENTATION_LOADED':
      return {...state, loaded: action.data};
    case 'SET_PRESENTATION_LOADED_IMGS':
      return {...state, loaded_imgs: action.data};  
    case 'GET_PRESENTATION_SESSIONS':
      return {...state, sessions: action.data};
    case 'SET_PRESENTATION_ORDERS':
      return {...state, items: state.items.map(item => {
        let index = findIndex(action.data, ['id', item.id]);
        if(index > -1){
          item.order_x = action.data[index].order_x;
        }
        return {...item};
      })}
    case 'SET_PRESENTATION_SLIDE':
      return {...state, slide: action.data} 
    case 'ADD_PRESENTATION_ITEM':
      return {...state, items: [...state.items, {...action.data, order_x: isNaN(parseInt(action.data.order_x)) ? action.data.order_x : parseInt(action.data.order_x)}]} 
    case 'DELETE_PRESENTATION_ITEM':
      return {...state, slide: null, items: [...state.items.filter(item => item.id != action.data)]}
    case 'DELETE_PRESENTATION_ITEMS':
      return {...state, slide: null, items: [...state.items.filter(item => !action.data.includes(item.id) )]}
    case 'CLEAR_PRESENTATION':
      return defaultState 
    default:
      return state;
  }
}

export default presentation;


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/reducers/presentation.js